"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiRequest = apiRequest;
exports.isTargetProxy = isTargetProxy;
exports.shouldUseAPIConsoleProxy = shouldUseAPIConsoleProxy;
exports.toARCResponseEvent = toARCResponseEvent;
exports.urlInExternalDomain = urlInExternalDomain;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _url = require("url");
var _debug = _interopRequireDefault(require("debug"));
var HEADER_REGEX = /^([^:]+): ((?:\n|.)*)$/;
var log = (0, _debug.default)('apiconsole:proxy');
var REDIRECT_TYPE = 'opaqueredirect';
function apiRequest() {
  return _apiRequest.apply(this, arguments);
}
function _apiRequest() {
  _apiRequest = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
    var _ref,
      organizationId,
      authorization,
      _ref$isAPIBehindFirew,
      isAPIBehindFirewall,
      _ref$isExternalDomain,
      isExternalDomain,
      _ref$isMockingService,
      isMockingServiceInstance,
      organizationDomain,
      proxyURL,
      requestDetail,
      _global3,
      Request,
      Response,
      fetch,
      performance,
      url,
      method,
      headers,
      payload,
      isUsingAPIConsoleProxy,
      requestURL,
      fetchHeaders,
      options,
      request,
      startTime,
      response,
      responseDetail,
      responseConfig,
      _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, organizationId = _ref.organizationId, authorization = _ref.authorization, _ref$isAPIBehindFirew = _ref.isAPIBehindFirewall, isAPIBehindFirewall = _ref$isAPIBehindFirew === void 0 ? false : _ref$isAPIBehindFirew, _ref$isExternalDomain = _ref.isExternalDomain, isExternalDomain = _ref$isExternalDomain === void 0 ? true : _ref$isExternalDomain, _ref$isMockingService = _ref.isMockingServiceInstance, isMockingServiceInstance = _ref$isMockingService === void 0 ? false : _ref$isMockingService, organizationDomain = _ref.organizationDomain, proxyURL = _ref.proxyURL, requestDetail = _ref.requestDetail;
          _global3 = global, Request = _global3.Request, Response = _global3.Response, fetch = _global3.fetch, performance = _global3.performance;
          url = requestDetail.url, method = requestDetail.method, headers = requestDetail.headers, payload = requestDetail.payload;
          isUsingAPIConsoleProxy = shouldUseAPIConsoleProxy({
            isAPIConsoleProxyEnabled: !!proxyURL,
            isExternalDomain: isExternalDomain,
            isAPIBehindFirewall: isAPIBehindFirewall
          });
          requestURL = getRequestURL(url, proxyURL, organizationDomain, isUsingAPIConsoleProxy);
          fetchHeaders = parseHeaders(headers);
          if (isMockingServiceInstance) {
            fetchHeaders.append('MS2-Origin', 'Exchange');
            if (authorization && !isTargetProxy(proxyURL, url)) {
              fetchHeaders.append('MS2-Authorization', authorization);
            }
          }
          if (isUsingAPIConsoleProxy && organizationId) {
            fetchHeaders.append('ms-organization-id', organizationId);
            if (authorization) {
              fetchHeaders.append('ms-authorization', authorization);
            }
          }
          options = {
            method: method,
            headers: fetchHeaders,
            redirect: 'manual'
          };
          if (payload) {
            options.body = payload;
          }
          request = new Request(requestURL, options);
          startTime = performance.now();
          log('proxing request', request);
          _context.prev = 13;
          _context.next = 16;
          return fetch(request);
        case 16:
          response = _context.sent;
          log('proxied response', response);
          responseDetail = {
            request: request,
            response: response,
            loadingTime: performance.now() - startTime
          };
          if (response.type === REDIRECT_TYPE) {
            responseConfig = {
              status: 302,
              statusText: 'Found'
            };
            responseDetail.response = new Response('Details are not exposed due to browser security policies.', responseConfig);
          } else if (!response.ok) {
            responseDetail.error = response.statusText;
          }
          return _context.abrupt("return", responseDetail);
        case 23:
          _context.prev = 23;
          _context.t0 = _context["catch"](13);
          log('error received', _context.t0);
          return _context.abrupt("return", {
            request: request,
            response: Response.error(),
            loadingTime: performance.now() - startTime,
            error: _context.t0
          });
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[13, 23]]);
  }));
  return _apiRequest.apply(this, arguments);
}
function toARCResponseEvent(_ref2) {
  var request = _ref2.request,
    response = _ref2.response,
    responseText = _ref2.responseText,
    loadingTime = _ref2.loadingTime,
    error = _ref2.error,
    requestId = _ref2.requestId;
  var _global = global,
    CustomEvent = _global.CustomEvent;
  var responseEvent = new CustomEvent('api-response', {
    cancelable: true,
    bubbles: true,
    composed: true,
    detail: {
      id: requestId,
      request: toARCRequest(request),
      response: toARCResponse(response, responseText),
      loadingTime: loadingTime,
      error: error,
      isError: !!error,
      isXhr: true
    }
  });
  return responseEvent;
}
function toARCRequest(request) {
  return {
    url: request.url,
    method: request.method,
    headers: headersToString(request.headers)
  };
}
function toARCResponse(response, responseText) {
  return {
    status: response.status,
    statusText: response.statusText,
    headers: headersToString(response.headers),
    payload: responseText
  };
}
function headersToString(headers) {
  return headersToArray(headers).map(function (entry) {
    return "".concat(entry[0], ": ").concat(entry[1]);
  }).join('\n');
}

/**
 * This uses the iterator protocol directly (i.e. calling next() - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#The_iterable_protocol)
 * due to a bug with IE11. Other ways of iteration (Array.from, for...of, [...]) don't work.
 */
function headersToArray(headers) {
  var result = [];
  var entries = headers.entries();
  var nextEntry = entries.next();
  while (!nextEntry.done) {
    result.push(nextEntry.value);
    nextEntry = entries.next();
  }
  return result;
}
function parseHeaders(headers) {
  var _global2 = global,
    Headers = _global2.Headers;
  var fetchHeaders = new Headers();
  (headers || '').split(/\n(?=[^ \t]+)/gim).map(function (header) {
    return header.replace(/\n[ \t]+/gim, '\n');
  }).forEach(function (header) {
    if (HEADER_REGEX.test(header)) {
      var matchedGroups = HEADER_REGEX.exec(header);
      fetchHeaders.append(matchedGroups[1], matchedGroups[2]);
    }
  });
  return fetchHeaders;
}
function getRequestURL(url, proxyURL, organizationDomain, isUsingAPIConsoleProxy) {
  if (!isUsingAPIConsoleProxy) {
    return url;
  }
  return "".concat(proxyURL, "organizations/").concat(organizationDomain, "/").concat(url);
}
function isTargetProxy(proxyURL, url) {
  if (!proxyURL || !url) {
    return false;
  }
  var _URL = new URL(proxyURL),
    proxyHost = _URL.host,
    proxyPathname = _URL.pathname;
  var _URL2 = new URL(url),
    host = _URL2.host,
    pathname = _URL2.pathname;
  return proxyHost === host && pathname.startsWith(proxyPathname);
}
function urlInExternalDomain(requestURL, isForwardedHost, forwardedHost, config) {
  var requestHostname = (0, _url.parse)(requestURL).hostname;
  var platformHostname = (0, _url.parse)((0, _url.format)(config.platform.uri)).hostname;
  var browserLocationHostname = isForwardedHost ? forwardedHost : platformHostname;
  return requestHostname !== browserLocationHostname;
}
function shouldUseAPIConsoleProxy(_ref3) {
  var isAPIConsoleProxyEnabled = _ref3.isAPIConsoleProxyEnabled,
    isExternalDomain = _ref3.isExternalDomain,
    isAPIBehindFirewall = _ref3.isAPIBehindFirewall;
  return isAPIConsoleProxyEnabled && isExternalDomain && !isAPIBehindFirewall;
}
//# sourceMappingURL=utils.js.map